<div class="comment-popup">
  <div class="comment-popup-body">
    @if (authorName !== null) {
      <app-suggestion-meta [authorName]="authorName" [createdAtRelative]="createdAtRelative"></app-suggestion-meta>
    }
    @if (commentBody !== null) {
      <div class="comment-popup-comment-body">{{ commentBody }}</div>
    }
    <button type="button" class="comment-popup-view-thread" (click)="onViewThread()">
      <mat-icon>forum</mat-icon>
      <span>{{ 'EDITOR.COMMENTS.VIEW_THREAD' | translate }}</span>
    </button>
  </div>
</div>
